import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationError } from '@core/models/error.model';
import { TranslocoService } from '@ngneat/transloco';
import { HttpStatusCodesEnum } from '@utils';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

type ErrorHandling = (err: ApplicationError) => void;

@Injectable()
export class RestErrorAuthInterceptor implements HttpInterceptor {

  private handlingMap = new Map<HttpStatusCodesEnum, ErrorHandling>([
    [HttpStatusCodesEnum.unauthorized, (err) => {
      if (err.errors?.some(e => e.code === 'passwordExpired')) {
        this.router.navigateByUrl('/change-password');
      } else {
        this.router.navigateByUrl('/login');
      }
      this.toast.error(
        this.createErrorMessage(err),
        this.translocoSvc.translate('messages.unauthorized')
      );
    }],
    [HttpStatusCodesEnum.forbidden, (err) => {
      this.toast.error(
        this.createErrorMessage(err),
        this.translocoSvc.translate('messages.forbidden'),
      );
    }]
  ]);

  constructor(
    private router: Router,
    private toast: ToastrService,
    private translocoSvc: TranslocoService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      const fn = this.handlingMap.get(err.status);
      if (fn) {
        fn(err.error);
      }
      return throwError(err);
    }));
  }

  private createErrorMessage(err: ApplicationError): string {
    const { errors } = err;
    let errorsString = '';
    if (errors && errors.length > 0) {
      errorsString = errors.map(e => `<li>${this.translocoSvc.translate('messages.errors.' + e.code, e.data)}</li>`).join('');
    }
    const result = errorsString ? `<ul>${errorsString}</ul>` : '';
    return result;
  }
}
